module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id=\'attributes-accordion\'></div>\n<div id=\'zones-accordion\'></div>\n<div id=\'circuits-accordion\'></div>\n<div id=\'folders-accordion\'></div>\n<div id=\'tenants-accordion\'></div>\n';

}
return __p
}